export interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  duration: string;
  features: string[];
  image: string;
  category: 'subscription' | 'hardware';
  popular?: boolean;
}

export const products: Product[] = [
  {
    id: 'esiptv-3m',
    name: 'Abonnement ESIPTV 3 Mois',
    description: 'Idéal pour tester notre service premium avec un accès complet.',
    price: 20,
    duration: '3 Mois',
    features: [
      '80,000+ Chaînes en direct',
      '100,000+ VODs & Séries',
      'Qualité 4K & FHD',
      'Technologie Anti-Coupure',
      'Support 24/7'
    ],
    image: '/img/product.png',
    category: 'subscription'
  },
  {
    id: 'esiptv-6m',
    name: 'Abonnement ESIPTV 6 Mois',
    description: 'Profitez de six mois de divertissement ininterrompu.',
    price: 30,
    duration: '6 Mois',
    features: [
      '80,000+ Chaînes en direct',
      '100,000+ VODs & Séries',
      'Qualité 4K & FHD',
      'Technologie Anti-Coupure',
      'Support 24/7'
    ],
    image: '/img/product.png',
    category: 'subscription'
  },
  {
    id: 'esiptv-12m',
    name: 'Abonnement ESIPTV 12 Mois',
    description: 'Notre forfait le plus populaire pour une année complète de streaming.',
    price: 39,
    duration: '12 Mois',
    features: [
      '80,000+ Chaînes en direct',
      '100,000+ VODs & Séries',
      'Qualité 4K & FHD',
      'Technologie Anti-Coupure',
      'Support 24/7',
      'Mises à jour gratuites'
    ],
    image: '/img/product.png',
    category: 'subscription',
    popular: true
  },
  {
    id: 'esiptv-12m-smarters',
    name: 'Abonnement ESIPTV 12 Mois + Smarters',
    description: 'Une année complète incluant l\'application premium Smarters.',
    price: 45,
    duration: '12 Mois + App',
    features: [
      'Application Smarters Pro incluse',
      '80,000+ Chaînes en direct',
      '100,000+ VODs & Séries',
      'Qualité 4K & FHD',
      'Technologie Anti-Coupure',
      'Support 24/7'
    ],
    image: '/img/product.png',
    category: 'subscription'
  },
  {
    id: 'esiptv-15m',
    name: 'Abonnement ESIPTV 15 Mois',
    description: 'Plus d\'une année de contenu premium à un prix avantageux.',
    price: 45,
    duration: '15 Mois',
    features: [
      '80,000+ Chaînes en direct',
      '100,000+ VODs & Séries',
      'Qualité 4K & FHD',
      'Technologie Anti-Coupure',
      'Support 24/7'
    ],
    image: '/img/product.png',
    category: 'subscription'
  },
  {
    id: 'esiptv-18m',
    name: 'Abonnement ESIPTV 18 Mois',
    description: 'Un an et demi de divertissement sans compromis.',
    price: 55,
    duration: '18 Mois',
    features: [
      '80,000+ Chaînes en direct',
      '100,000+ VODs & Séries',
      'Qualité 4K & FHD',
      'Technologie Anti-Coupure',
      'Support 24/7'
    ],
    image: '/img/product.png',
    category: 'subscription'
  },
  {
    id: 'esiptv-24m',
    name: 'Abonnement ESIPTV 24 Mois',
    description: 'Deux années de tranquillité avec notre service ultra-stable.',
    price: 70,
    duration: '24 Mois',
    features: [
      '80,000+ Chaînes en direct',
      '100,000+ VODs & Séries',
      'Qualité 4K & FHD',
      'Technologie Anti-Coupure',
      'Support 24/7'
    ],
    image: '/img/product.png',
    category: 'subscription'
  },
  {
    id: 'esiptv-36m',
    name: 'Abonnement ESIPTV 36 Mois',
    description: 'Le meilleur rapport qualité-prix pour 3 ans de streaming.',
    price: 85,
    duration: '36 Mois',
    features: [
      '80,000+ Chaînes en direct',
      '100,000+ VODs & Séries',
      'Qualité 4K & FHD',
      'Technologie Anti-Coupure',
      'Support 24/7',
      'Priorité Support VIP'
    ],
    image: '/img/product.png',
    category: 'subscription'
  },
  {
    id: 'firestick-promo',
    name: 'Amazon FireStick 4K + 12M IPTV',
    description: 'Obtenez le matériel et l\'abonnement dans un pack puissant.',
    price: 99.00,
    duration: '12 Mois + Matériel',
    features: [
      'Amazon FireStick 4K Inclus',
      '12 Mois d\'IPTV Premium',
      'Préconfiguré & Prêt à l\'emploi',
      'Livraison Express Gratuite',
      'Télécommande vocale Alexa'
    ],
    image: '/img/product-fs.png',
    category: 'hardware'
  }
];

export const faqs = [
  {
    question: 'Comment vais-je recevoir mon abonnement ?',
    answer: 'Une fois votre paiement confirmé, vous recevrez un email avec vos identifiants de connexion et les instructions de configuration dans les 5 minutes.'
  },
  {
    question: 'Puis-je utiliser mon abonnement sur plusieurs appareils ?',
    answer: 'Oui, vous pouvez installer notre application sur plusieurs appareils, mais vous ne pouvez regarder que sur un seul appareil à la fois, sauf si vous achetez un forfait multi-connexions.'
  },
  {
    question: 'Ai-je besoin d\'un VPN ?',
    answer: 'Notre service intègre une technologie anti-blocage, un VPN n\'est donc pas strictement nécessaire. Cependant, vous êtes libre d\'en utiliser un si vous le préférez.'
  },
  {
    question: 'Quelle vitesse internet est requise ?',
    answer: 'Nous recommandons un minimum de 15 Mbps pour le streaming HD et de 30 Mbps pour le streaming 4K afin de garantir une expérience sans coupure.'
  }
];
